import { combineReducers } from 'redux';
import data from './navigationReducer';

export default combineReducers({
    data: data
});
